export async function copyToClipboard(text: string): Promise<boolean> {
  if (navigator.clipboard && window.isSecureContext) {
    try {
      await navigator.clipboard.writeText(text)
      return true
    } catch (error) {
      console.error('Clipboard API failed, trying fallback:', error)
    }
  }

  try {
    return copyToClipboardLegacy(text)
  } catch (error) {
    console.error('Legacy copy method failed:', error)
    return false
  }
}

function copyToClipboardLegacy(text: string): boolean {
  const textArea = document.createElement('textarea')
  textArea.value = text
  textArea.style.position = 'fixed'
  textArea.style.top = '-9999px'
  textArea.style.left = '-9999px'
  textArea.style.opacity = '0'
  textArea.setAttribute('readonly', '')

  document.body.appendChild(textArea)

  try {
    textArea.select()
    textArea.setSelectionRange(0, text.length)

    const successful = document.execCommand('copy')
    return successful
  } finally {
    document.body.removeChild(textArea)
  }
}
